export const parseBooleanEnv = (value, defaultValue = false) => {
    if (typeof value === 'boolean') {
        return value;
    }

    if (typeof value === 'string') {
        const normalizedValue = value.trim().toLowerCase();

        if (normalizedValue === 'true' || normalizedValue === '1') {
            return true;
        }

        if (normalizedValue === 'false' || normalizedValue === '0') {
            return false;
        }
    }

    return defaultValue;
};

const parsePluginsOnlyHighlightMode = (value) => {
    const normalizedValue = String(value ?? '').trim().toLowerCase();
    if (['ab', 'plugins', 'pro', 'off'].includes(normalizedValue)) {
        return normalizedValue;
    }
    return 'ab';
};

export default {
    googleClientId: '502623596250-fb14kii7v91qf3afpovmjocbrbq36kpn.apps.googleusercontent.com',
    appleClientId: process.env.REACT_APP_APPLE_CLIENT_ID || '',
    facebookAppId: '486867391337544',
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_KEY || '6LccoQUqAAAAAPYrX7nzBo34lSNigjeXARgbu1b9',
    sessionTokenLocalStorageKey: process.env.REACT_APP_SESSION_TOKEN_LOCAL_STORAGE_KEY || 'token',
    refreshTokenLocalStorageKey: process.env.REACT_APP_REFRESH_TOKEN_LOCAL_STORAGE_KEY || 'refresh_token',
    sessionTokenCookieKey: process.env.REACT_APP_SESSION_TOKEN_COOKIE_KEY || 'newLogin',
    refreshTokenCookieKey: process.env.REACT_APP_REFRESH_TOKEN_COOKIE_KEY || 'newLogin_refresh',
    premiumAssetsSubscriptionCookieKey: process.env.REACT_APP_PREMIUM_ASSETS_SUBSCRIPTION_COOKIE_KEY || 'cratePremiumAssetsSubscription',
    pluginsOnlyHighlightMode: parsePluginsOnlyHighlightMode(process.env.REACT_APP_PLUGINS_ONLY_HIGHLIGHT_MODE),
    announcementsEnabled: parseBooleanEnv(process.env.REACT_APP_ANNOUNCEMENTS_ENABLED, false),
    cookieDomain: process.env.REACT_APP_COOKIE_DOMAIN || null,
    marketplaceCartCookieKey: process.env.REACT_APP_MARKETPLACE_CART_COOKIE_KEY || null,
}
  
